import { useCallback, useState } from "react";
import { useAddCustomerMutation, useLazyGetCustomerByPhoneQuery } from "@/features/organizations/api/orgCustomersApi";
import { AnonymousUser } from "@/types";
import { useAddUserOrgOrderMutation } from "@/api/userOrgOrdersApi";

interface UseCustomerProps {
  organizationId: string;
}

export const useCustomer = ({ organizationId }: UseCustomerProps) => {
  const [addCustomer] = useAddCustomerMutation();
  const [addUserOrgOrder] = useAddUserOrgOrderMutation();
  const [getCustomerByPhone] = useLazyGetCustomerByPhoneQuery();
  const [existsCustomer, setExistsCustomer] = useState<boolean | null>(null);

  //  Obtener o crear cliente
  const getOrCreateCustomer = useCallback(
    async (phone: string, draft?: Partial<AnonymousUser>) => {
      if (!draft) {
        throw new Error("Draft requerido para crear cliente");
      }

      const results = await getCustomerByPhone({
        organizationId,
        phone,
      });

      if (results?.data?.length) {
        setExistsCustomer(true);
        return results.data[0];
      }

      const newCustomer = await addCustomer({
        organizationId,
        draft,
      }).unwrap();

      if (newCustomer?.error) {
        return newCustomer.error;
      }
      return newCustomer;
    },
    [addCustomer, getCustomerByPhone, organizationId]
  );

  // Añadir orden al usuario
  const addOrderToCustomer = useCallback(
    async ({ userId, orderId, subtotal, total }: { userId: string; orderId: string; subtotal: number; total: number }) => {
      return await addUserOrgOrder({
        userId,
        organizationId,
        orderId,
        subtotal,
        total,
      }).unwrap();
    },

    [addUserOrgOrder, organizationId]
  );

  return {
    existsCustomer,
    getOrCreateCustomer,
    addOrderToCustomer,
  };
};
